import {
  WMS_Po_Variance_Post_Api,
  WMS_Po_Variance_Getrow_Api,
  WMS_Po_Reverse_Variance_Post_Api,
} from "../../Server/ApiV2";
// HR Monthly Evaluation Update
export const WMS_PO_VARIANCE_GETROW = async (postData) => {
  try {
    const response = await WMS_Po_Variance_Getrow_Api(postData);
    return response;
  } catch (err) {
    console.error("An error occurred:", err);

    return null;
  }
};

// HR Monthly Evaluation Head POST
export const WMS_PO_VARIANCE_POST = async (postData) => {
  try {
    const response = await WMS_Po_Variance_Post_Api(postData);
    return response;
  } catch (err) {
    console.error("An error occurred:", err);

    return null;
  }
};
export const WMS_PO_REVERSE_VARIANCE_POST = async (postData) => {
  try {
    const response = await WMS_Po_Reverse_Variance_Post_Api(postData);
    return response;
  } catch (err) {
    console.error("An error occurred:", err);

    return null;
  }
};